import { cn } from "@gymflow/helpers";
import classNames from "classnames";
import { Field, useFormikContext } from "formik";

const baseClasses =
  "block h-11 w-full flex-1 rounded-lg py-2.5 px-3.5 text-gray-900 placeholder:text-gray-400  sm:text-sm sm:leading-6 dark:bg-gray-950 dark:placeholder:text-gray-500 dark:!text-gray-50 border-0 bg-gray-0";
const defaultColors = "border border-gray-200 dark:!border-gray-800";

const TextInputClassNames = cn(baseClasses, defaultColors);
interface FormikTextInputProps
  extends Omit<React.HTMLProps<HTMLInputElement>, "type"> {
  type:
    | "email"
    | "number"
    | "text"
    | "password"
    | "search"
    | "tel"
    | "url"
    | "textarea";
  hideErrors?: boolean;
}

/**
 * @deprecated use atoms/form/FormInput instead
 */
export function FormikTextInput({
  className,
  type,
  hideErrors,
  ...props
}: FormikTextInputProps) {
  const { touched, errors }: any = useFormikContext();
  const fieldName = props.name as string;
  const hasErrors = touched[fieldName] && errors[fieldName];
  return (
    <div className="w-full">
      <div className="flex w-full">
        <Field
          type={type}
          className={classNames(TextInputClassNames, className)}
          {...props}
        />
      </div>
      {!hideErrors && hasErrors && (
        <div className="flex w-full">
          <div className="text-error-600 ml-3.5 mt-2">{errors[fieldName]}</div>
        </div>
      )}
    </div>
  );
}

FormikTextInput.defaultProps = {
  type: "text",
};
